import { useTranslation } from 'react-i18next';
import Input from 'components/Input';
import Button from 'components/Button';
import { useGlobalConfigContext } from 'GlobalConfig.context';
import { Stack } from 'components/Stack';
import { Combobox } from 'components/Combobox';

import { useSearchDropOff } from './useSearchDropOff';
import { useCountryOptions } from './useCountryOptions';
import type { SearchDropOffValues } from './SearchDropOff.interfaces';

interface SearchDropOffProps {
  isLoading: boolean;
  onSearch: (values: SearchDropOffValues) => void;
}

export const SearchDropOff = ({
  isLoading,
  onSearch,
}: SearchDropOffProps): JSX.Element => {
  const { t } = useTranslation();
  const { config: configs } = useGlobalConfigContext();
  const { return: returnConfig } = configs;
  const { returnCountry } = returnConfig;
  const countryOptions = useCountryOptions(returnCountry, t);

  const {
    values,
    errors,
    onChangeCountryCode,
    onChangePostalCode,
    onSearchDropOff,
    onFormatPostalCode,
  } = useSearchDropOff({ onSearch });

  return (
    <Stack direction="column" gap={16} align="stretch" isFullWidth>
      <Stack direction="column" gap={8} align="stretch" isFullWidth>
        <Combobox
          value={values.countryCode}
          hasError={!!errors.countryCode}
          helpText={t(errors.countryCode)}
          options={countryOptions}
          placeholder={t('RETURN_SELECT_COUNTRY')}
          onSelect={onChangeCountryCode}
          required
          aria-label={t('RETURN_SELECT_COUNTRY')}
        />
        <Input
          name="input-postal-code"
          value={values.postalCode}
          error={t(errors.postalCode)}
          placeholder={t('RETURN_INPUT_POSTAL_CODE')}
          onChange={onChangePostalCode}
          onBlur={onFormatPostalCode}
          required
        />
      </Stack>

      <Button onClick={onSearchDropOff} disabled={isLoading}>
        {t('RETURN_SEARCH_FOR_DROPOFF_LOCATIONS')}
      </Button>
    </Stack>
  );
};
